'use client';

import classNames from 'classnames';

import PopularCourseItem from '~/shared/components/header/components/popular-course-item/popular-course-item';
import usePopularCourses from '~/shared/components/header/components/popular-courses/use-popular-courses';
import NoData from '~/shared/components/no-data';
import type { Locale } from '~/universal/constants';

import './popular-courses.scss';

import pranaBgSvg from '~/assets/prana-bg.svg?url';
import AllCourses from '~/shared/components/header/components/all-courses';

type PopularCoursesProps = Readonly<{
  lng: Locale;
  closeDropdown?: () => void;
}>;

const PopularCourses = ({ lng, closeDropdown }: PopularCoursesProps) => {
  const { t, freeItems, freeLoading, freeError, paidItems, paidLoading, paidError } = usePopularCourses({ lng });

  return (
    <nav itemScope itemType="https://schema.org/SiteNavigationElement" className="popular-courses">
      <AllCourses closeDropdown={closeDropdown} t={t} lng={lng} />
      <div className="popular-courses__courses-block">
        <div className="popular-courses__title">{t('text.paid-courses')}:</div>

        <div className="popular-courses__list">
          {paidItems.length > 0 ? (
            paidItems.map(({ _id, item }) => (
              <div className="popular-courses__list-item" key={_id}>
                <PopularCourseItem
                  isLoading={paidLoading}
                  isError={paidError}
                  onClick={closeDropdown}
                  data={item}
                  lng={lng}
                  t={t}
                />
              </div>
            ))
          ) : (
            <NoData variant="web" t={t} />
          )}
        </div>
      </div>

      <div
        className={classNames('popular-courses__courses-block', {
          'popular-courses__courses-block--full-width': freeItems.length === 0,
        })}
      >
        <div className="popular-courses__title">{t('text.free-courses')}:</div>

        <div className="popular-courses__list">
          {freeItems.length > 0 ? (
            freeItems.map(({ _id, item }) => (
              <div className="popular-courses__list-item" key={_id}>
                <PopularCourseItem
                  isLoading={freeLoading}
                  isError={freeError}
                  onClick={closeDropdown}
                  data={item}
                  lng={lng}
                  t={t}
                />
              </div>
            ))
          ) : (
            <NoData variant="web" t={t} />
          )}
        </div>
      </div>
      <img src={pranaBgSvg} alt="" className="popular-courses__bg" />
    </nav>
  );
};

export default PopularCourses;
